import { valibotResolver } from '@hookform/resolvers/valibot';
import { array, minLength, nonEmpty, nullable, number, object, optional, pipe, string, trim } from 'valibot';

import type { IFacilityGroup } from '@model/facilityGroup';

export const FACILITY_GROUP_FIELDS = {
  GROUP_ID: 'id',
  NAME: 'name',
  LOCATION_IDS: 'location_ids',
};

export const schemaFacilityGroup = () =>
  valibotResolver(
    object({
      [FACILITY_GROUP_FIELDS.GROUP_ID]: optional(nullable(number())),
      [FACILITY_GROUP_FIELDS.NAME]: pipe(string(), trim(), nonEmpty('This field is required.')),
      [FACILITY_GROUP_FIELDS.LOCATION_IDS]: pipe(array(number()), minLength(1, 'Please select facilities.')),
    }),
  );

export const facilityGroupDefaultValues = (facilityGroup?: IFacilityGroup) => {
  const facilitiesIdsList = facilityGroup?.children?.map((facility) => facility.id) || [];

  return {
    [FACILITY_GROUP_FIELDS.GROUP_ID]: facilityGroup?.id || null,
    [FACILITY_GROUP_FIELDS.NAME]: facilityGroup?.name || '',
    [FACILITY_GROUP_FIELDS.LOCATION_IDS]: facilitiesIdsList,
  };
};
